import { Record } from 'immutable';
import { LookupAddress } from '../../event/models/lookup-address';

const PropertyLookupSummaryRecord = Record({
  chain: null,
  brand: null,
  propertyId: null,
  name: null,
  address: new LookupAddress({})
});

export class PropertyLookupSummary extends PropertyLookupSummaryRecord {
  chain: string;
  brand: string;
  propertyId: string;
  name: string;
  address: LookupAddress;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/models/property-lookup-summary.ts